import { GroupChatManagementScreenNavigationProps } from "./types"
import React from "react"
import GroupChatManagement from "./group-chat-management-screen"
import { PageRoot } from "~screens/page-root"
import { useRouteChatId } from "~hooks/useActiveChat"


const GroupChatManagementScreen: React.FC<GroupChatManagementScreenNavigationProps> = (props) => {
  const chatKey = useRouteChatId() ?? "default"
  return (
    <PageRoot>
      <GroupChatManagement key={chatKey} {...props}/>
    </PageRoot>
  )
}

export default GroupChatManagementScreen
